<template>
    <v-app-bar color="#137db6" clipped-left flat>
        <v-container>
            <v-row>
                <v-col cols="6">
                    <v-toolbar-title>
                        <h1>
                            <a :href="logoLink" title="">
                                <img :src="logo" class="logo mx-auto mx-sm-0 d-flex" :alt="$store.state.client_vars.APP_NAME"/>
                            </a>
                        </h1>
                    </v-toolbar-title>
                </v-col>
                <v-col v-if="$store.state.hasMounted" cols="6" class="align-center d-flex justify-space-around justify-sm-end">
                    <a :href="socialData.facebookURL" v-if="socialData.facebookEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/fb.svg" alt="Facebook link" />
                    </a>
                    <!-- <a :href="socialData.instagramURL" v-if="socialData.instagramEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/in.svg" alt="Instagram link" />
                    </a>
                    <a :href="socialData.twitterURL" v-if="socialData.twitterEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/twitter.svg" alt="Twitter link" />
                    </a>
                    <a :href="socialData.youtubeURL" v-if="socialData.youtubeEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/Youtube.svg" alt="Youtube link" />
                    </a>
                    <a :href="socialData.linkedinURL" v-if="socialData.linkedinEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/Linkedin.svg" alt="LinkedIn link" />
                    </a> -->
                    <a :href="socialData.homeURL" v-if="socialData.homeLinkEnable" target="_blank">
                        <img width="32px" class="mr-sm-6" src="@/assets/icons/home.svg" alt="Home link" />
                    </a>
                </v-col>
            </v-row>
            <!-- <v-btn icon @click="$emit('drawerClicked')" class="mr-11">
                <img style="width:40px; height:28px;" src="@/assets/icons/burger.svg" />
            </v-btn> -->
            <!-- <v-app-bar-nav-icon @click="$emit('drawerClicked')" color="white"></v-app-bar-nav-icon> -->
        </v-container>
    </v-app-bar>
</template>

<script>
  export default {
      computed: {
          socialData() {
            return this.$store.getters.getSocialSettings
          },
          logo() {
            return this.$store.getters.getLogo
          },
          logoLink() {
            return this.$store.getters.getLogoLink
          }
      }
  }
</script>

<style lang="scss">
    .v-toolbar__content {
        height: auto!important;
        max-height: 125px;
    }
    .v-toolbar {
        flex: 0 0 auto;
        height: auto!important;

        .logo {
            // width: 250px;
            // height: 85px;
            max-width: 100%;

            @media (min-width: 600px) {
                max-width: 213px;
                max-height: 110px;
            }
        }

        &__content {
            height: auto!important;

            .container {
                justify-content: space-between;
                display: flex;
                align-items: center;
            }
        }
    }
</style>